import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=c1295810&scoped=true"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"
import style0 from "./AlertList.vue?vue&type=style&index=0&id=c1295810&prod&lang=css"
import style1 from "./AlertList.vue?vue&type=style&index=1&id=c1295810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1295810",
  null
  
)

export default component.exports